module.exports = __webpack_public_path__ + "static/media/animeswa.84ba8434.png";